import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { c1, c16 } from "src/app/core/services/constants";
import { IndexDBService } from "src/app/core/services/indexDB.service";
import { MiddlwareService } from "src/app/core/services/middleware.service";
import { MessageAI, MessageAIModule, StartAIBuilder } from "src/app/core/services/outbound";
import { WebsocketService } from "src/app/core/services/websocket.service";

@Component({
  selector: "app-ai-popup",
  templateUrl: "./ai-popup.component.html",
  styleUrls: ["./ai-popup.component.scss"],
})

export class AIPopupComponent implements OnInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;
  @ViewChild('messagesContainer') private messagesContainer!: ElementRef<HTMLDivElement>;
  @Input() itemName;
  @Input() input;
  @Input() module;
  @Input() moduleId;
  @Input() moduleObject;
  @Input() component_ref = this.mdw.makeRef(16);
  @Output() outputNotifier = new EventEmitter<any>(null);
  @Output() closeNotifier = new EventEmitter<any>(null);

  schemeChangeSubscription: any;
  updatedBuilderComponentSubscription: any;
  getAppConfigSubscription: any;
  messageAIModuleSubscription: any;
  getAIModuleHistorySubscription: any;
  verifySubscription: any;
  minimized = false;
  fullscreen = false;
  inputText = '';
  web: string;

  showGrid = false;
  GRID_SIZE = 30;

  horizontalLines: number[] = [];
  verticalLines: number[] = [];

  // For 20 cells, we create 21 lines.
  // Each line is spaced from 0% to 100%.
  horizontalSpacing = 0;
  verticalSpacing = 0;

  // Each line starts at a random time (delay)
  delayArray: number[] = [];

  // Each line also gets a random speed (duration)
  speedArray: number[] = [];
  messages: any = [
    // {
    //   role: "assistant",
    //   content: "Hi,<br> Let’s get started with your app setup.<br>**First, tell me what your app is all about.**"
    // },
    // {
    //   role: "user",
    //   content: "Whatsapp"
    // }
  ]
  loadingMessage = false;
  thinkingMessage = false;
  doneMessage = false;
  errorMessage = false;
  isSidebarOpen = false;
  isSidebarFullscreen = false;
  isFullscreenContentVisible = false;

  startupAnimate = false;

  mode = "light";
  generating = false;
  theme = "frozen";
  placement = "frozen";
  signup = "frozen";
  onboarding = "frozen";
  custom = "frozen";
  uploading = "frozen";
  final = "frozen";
  completed_images;
  total_images;
  disableInput = false;
  state = 1000;
  remind = false;
  remindCounter = 0;
  showTopbar = false;

  app_info: any;
  app_icon: any;
  logoColor: any;
  updatedVersion: boolean;
  isAndroid: boolean;
  originalColors: any = {};

  messageQueue: any = [];
  isProcessingQueue = false;

  displayedMessage = "";
  messageIndex: number = 0;
  typingSpeed: number = 1; // Adjust speed as needed
  typingSessionId = 0;
  status;

  constructor(
    private ws: WebsocketService,
    private mdw: MiddlwareService,
    private indexDBService: IndexDBService,
    private cdr: ChangeDetectorRef

  ){}

  ngOnInit(): void {
    if (window.innerWidth <= 992) {
      this.GRID_SIZE = 20;
    }
    if (window.innerWidth <= 768) {
      this.GRID_SIZE = 15;
    }
    if(window.innerWidth <= 576){
      this.GRID_SIZE = 7;
    }
    this.showGrid = true;

    // Build arrays for 21 horizontal and 21 vertical lines
    this.horizontalLines = Array.from({ length: this.GRID_SIZE + 1 }, (_, i) => i);
    this.verticalLines   = Array.from({ length: this.GRID_SIZE + 1 }, (_, i) => i);

    // For 20 intervals → 100/20 = 5% spacing
    this.horizontalSpacing = 100 / this.GRID_SIZE;
    this.verticalSpacing   = 100 / this.GRID_SIZE;

    // Random delays (0 - 3s, e.g.)
    this.delayArray = Array.from({ length: this.GRID_SIZE + 1 }, () => Math.random() * 3);

    // Random speeds: for example, between 2s and 6s.
    // Adjust to your liking (speed range, etc.).
    this.speedArray = Array.from(
      { length: this.GRID_SIZE + 1 },
      () => 15 + Math.random() * 5
    );

    this.startupAnimate = true;

    if (!localStorage.getItem("light") && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
      this.mode = "dark";
    } else if (!localStorage.getItem("light") || localStorage.getItem("light") == "true") {
      this.mode = "light";
    } else if (localStorage.getItem("light") == "false") {
      this.mode = "dark";
    }

    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
      if (!localStorage.getItem("light")) {
        this.mode = event.matches ? "dark" : "light";
      } else {
        this.mode = localStorage.getItem("light") == "true" ? "light" : "dark";
      }
    });

    const vapp = JSON.parse(localStorage.getItem("vapp"));
    this.getAppConfigSubscription = this.mdw.getAppConfigContainer$.subscribe((data) => {
      if (data) {
        this.colorInitialize();
        if (!vapp) {
          // this.ws.processMethod(new GetApps(this.component_ref));
          // this.ws.processMethod(new GetAppStore(this.component_ref));
          // this.ws.processMethod(new GetAppsSetup(this.component_ref));
          // this.ws.processMethod(new ListAppRelease(this.component_ref));
        }
        const appInfo = this.indexDBService.getItem("item", "app_info");
          appInfo.onsuccess = async (event) => {
            if (appInfo.result) {
              this.app_info = appInfo.result;
              if (this.app_info.image) {
                this.app_icon = this.app_info.image;
              }
            }
          };
      }
    });

    this.schemeChangeSubscription = this.mdw.schemeChangeContainer$.subscribe((data) => {
      this.colorInitialize();
    });

    this.messageAIModuleSubscription = this.ws.messageAIModuleContainer$.subscribe((messageData) => {
      if(messageData){
        this.messageQueue.push(messageData);




    this.processMessageQueue();
    this.cdr.detectChanges();
      }
    });

    this.getAIModuleHistorySubscription = this.ws.getAIModuleHistoryContainer$.subscribe((moduleHistory) => {
      if(moduleHistory){
        console.log("moduleHistory", moduleHistory)

        if(moduleHistory.history){
          moduleHistory.history.forEach((chat, index) => {
            if(chat.role == 'assistant'){
              let json_response = JSON.parse(chat?.content);
              if(json_response.content != null){
                chat.content = json_response.content.replace(/\\n/g, '\n').replace(/\n/g, '\n\n')
              }else{
                chat.content = "";
                // moduleHistory.history.splice(index, 1);
              }
            }
            if(chat.role == 'user'){
              chat.content = chat.content[0].text.replace(/\\n/g, '\n').replace(/\n/g, '<br>');
            }
          });
          this.messages = moduleHistory.history;
          if(this.messages.length > 0 && !this.doneMessage){
            let lastMessage = this.messages[this.messages.length - 1];
            if (lastMessage.role === 'assistant') {
              this.displayedMessage = '';
              this.messageIndex = 0;
              this.startTypingNewMessage(lastMessage.content);
            }
          }
        console.log(this.messages);
        this.loadingMessage = false;
        this.disableInput = false;
        }
        if(moduleHistory.state){

          this.state = moduleHistory.state;
        console.log("state1", this.state)

        }
      }
    });

    this.verifySubscription = this.ws.verifyContainer$.subscribe((verifyData) => {
      if (verifyData) {

        console.log("The input", this.input);
        console.log("module: ", this.module, "moduleId:", this.moduleId, this.moduleObject, "Status:" ,"init", "ref:", this.component_ref);

        this.ws.processMethod(new StartAIBuilder(this.module, this.moduleId, "init", this.component_ref, this.moduleObject));

        this.loadingMessage = true;
        this.disableInput = true;
        this.updatedBuilderComponentSubscription = this.mdw.updateBuilderComponentContainer$.subscribe(async (data) => {
          if (data) {
            this.colorInitialize();
            // this.app_info = this.config.appConfig.app.system.app_info;;
            if (this.app_info && this.app_info.image) {
              this.app_icon = this.app_info.image;
            }
            if (
              this.app_info &&
              this.app_info.color_logo &&
              this.app_info.color_logo.bg
            ) {
              this.logoColor = this.app_info.color_logo_bg.bg;
            }
            this.updatedVersion = localStorage.getItem("version") == "1"? true: false;
          }
        });
      }
    });
  }


  ngAfterViewInit(): void {
    const card = document.getElementById('draggableCard')!;
    const handle = document.getElementById('dragHandle')!;
    const container = document.querySelector('.ai-wrapper') as HTMLElement;

    let dragging = false;
    let primed = false;
    let startX = 0, startY = 0;
    let offsetX = 0, offsetY = 0;
    const THRESHOLD = 4; // px

    function px(n: number) { return `${n}px`; }
    function num(v: string) { return parseFloat(v) || 0; }
    function isInteractive(target: EventTarget | null) {
      return (target instanceof Element) &&
            (target.closest('button, [role="button"], a, input, textarea, select, .no-drag') !== null);
    }

    if(handle){
      handle.addEventListener('pointerdown', (e: PointerEvent) => {
        if (this.fullscreen) return;
        if (isInteractive(e.target)) return;        // let the button click normally

        // Do NOT preventDefault here; allow click to fire if no drag
        primed = true;
        startX = e.clientX;
        startY = e.clientY;

        container.style.position ||= 'relative';
        card.style.position = 'absolute';

        // compute offset lazily when we cross threshold
        document.body.style.userSelect = 'none';
        handle.setPointerCapture(e.pointerId);
      });
    }

    window.addEventListener('pointermove', (e: PointerEvent) => {
      if (this.fullscreen) return;
      if (!primed) return;

      // become a drag only after threshold
      if (!dragging) {
        const dx = Math.abs(e.clientX - startX);
        const dy = Math.abs(e.clientY - startY);
        if (dx < THRESHOLD && dy < THRESHOLD) return;

        // now start actual drag: lock offsets
        const rect = card.getBoundingClientRect();
        offsetX = startX - rect.left;
        offsetY = startY - rect.top;
        dragging = true;
      }

      // container bounds
      const contRect = container.getBoundingClientRect();
      const styles = getComputedStyle(container);
      const padL = num(styles.paddingLeft);
      const padR = num(styles.paddingRight);
      const padT = num(styles.paddingTop);
      const padB = num(styles.paddingBottom);

      const cardW = card.offsetWidth;
      const cardH = card.offsetHeight;

      let left = e.clientX - contRect.left - offsetX;
      let top  = e.clientY - contRect.top  - offsetY;

      const minLeft = padL;
      const minTop  = padT;
      const maxLeft = container.clientWidth  - padR - cardW;
      const maxTop  = container.clientHeight - padB - cardH;

      left = Math.max(minLeft, Math.min(left, maxLeft));
      top  = Math.max(minTop,  Math.min(top,  maxTop));

      card.style.left = px(left);
      card.style.top = px(top);
      card.style.bottom = 'auto';
      card.style.transform = 'none';
    });

    window.addEventListener('pointerup', (e: PointerEvent) => {
      if (this.fullscreen) return;
      // If we actually dragged, prevent text selection and ghost click behavior
      if (dragging) e.preventDefault();

      dragging = false;
      primed = false;
      if(handle){
        handle.releasePointerCapture?.(e.pointerId);
      }
      document.body.style.userSelect = '';
    });
  }

  submitAnswer() {
    if (this.inputText.trim() && !(this.loadingMessage || this.doneMessage)) {
      this.messages.push({content: this.inputText, role: "user"})
      this.ws.processMethod(new MessageAIModule(this.inputText, this.state, this.module, this.moduleId, this.component_ref, this.remind));
      this.disableInput = true;
      this.loadingMessage = true;
      this.thinkingMessage = true;
      setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => {
        this.inputText = '';
        document.getElementById("inputArea").style.height = "";
        const container = this.scrollContainer?.nativeElement;
        if(container){
          container.scrollTop = container.scrollHeight;
        }
      });

    }
  }

  help(){
    this.disableInput = true;
    this.messages.push({content: "Can you give me some suggestions for how to answer?", role: "user"})
    this.ws.processMethod(new MessageAIModule("Can you give me some suggestions for how to answer?", this.state, this.module, this.moduleId, this.component_ref, this.remind));
    this.inputText = '';
    this.loadingMessage = true;
    this.thinkingMessage = true;
    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    });
  }

  accept(){
    this.disableInput = true;
    this.messages.push({content: "👍", role: "user"})
    this.ws.processMethod(new MessageAIModule("👍", this.state, this.module, this.moduleId, this.component_ref, this.remind));
    this.inputText = '';
    this.loadingMessage = true;
    this.thinkingMessage = true;
    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    });
  }

  decline(){
    this.disableInput = true;
    this.messages.push({content: "👎", role: "user"})
    this.ws.processMethod(new MessageAIModule("👎", this.state, this.module, this.moduleId, this.component_ref, this.remind));
    this.inputText = '';
    this.loadingMessage = true;
    this.thinkingMessage = true;
    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      const container = this.scrollContainer.nativeElement;
      container.scrollTop = container.scrollHeight;
    });
  }

  minimizeEditor(){
    this.fullscreen = false;
    this.minimized = !this.minimized;

    const card = document.getElementById('draggableCard') as HTMLElement | null;
    if (!card) return;

    if (!this.minimized) {
      // restore your bottom-center baseline
      card.style.left = '50%';
      card.style.top = 'auto';
      card.style.bottom = '0';
      card.style.transform = 'translateX(-50%)';
    }
  }

  fullscreenEditor(){
    this.minimized = false;
    this.fullscreen = !this.fullscreen;

    setTimeout(() => this.scrollToBottom(), 0);

    const card = document.getElementById('draggableCard') as HTMLElement | null;
    if (!card) return;

    if (this.fullscreen) {
      // center in its positioned container
      card.style.position = 'absolute';      // or 'fixed' if you want viewport
      card.style.left = '50%';
      card.style.top = '50%';
      card.style.bottom = '';                // unset bottom so top takes effect
      card.style.transform = 'translate(-50%, -50%)';
    } else {
      // restore your bottom-center baseline
      card.style.left = '50%';
      card.style.top = 'auto';
      card.style.bottom = '0';
      card.style.transform = 'translateX(-50%)';
    }
  }

  closeEditor(){
    this.closeNotifier.emit(true);
  }

  onScroll(event: Event): void {
    const element = event.target as HTMLElement;
    const scrollTop = element.scrollTop;

    if (scrollTop > 0) {
      this.showTopbar = true;
    } else {
      this.showTopbar = false;
    }
  }

  onSidebarTransitionEnd(event: TransitionEvent) {
    if (this.isSidebarFullscreen && event.propertyName === 'width') {
      this.isFullscreenContentVisible = true;
    }
  }

  adjustHeight(event: Event): void {
    const textarea = event.target as HTMLTextAreaElement;
    textarea.style.height = 'auto';
    textarea.style.height = `${textarea.scrollHeight}px`;
  }

  colorInitialize(){
    try {
      const appHome = this.indexDBService.getItem("app", 'home');
      appHome.onsuccess = async (event) => {
        if (appHome.result) {
          this.originalColors['color_schema'] = appHome.result.app.tabs.color_schema;
          this.originalColors['color_schema_ios'] = appHome.result.app.tabs.color_schema_ios;
          this.originalColors['light'] = localStorage.getItem("mode")[15] == c16.LIGHT? true:false
          this.isAndroid = localStorage.getItem("mode")[0] == c1.ANDROID? true: false;
        }
      }
    } catch (error) {
    }
  }

  getLogoBackground(){
    if(this.originalColors.color_schema){
      return this.isAndroid ? this.originalColors.color_schema.schemes.light.icLauncherBackground : '#ffffff';
    } else {
      return '#ffffff';
    }
  }

  scrollToBottom() {
    if (this.messagesContainer) {
      this.messagesContainer.nativeElement.scrollTop = this.messagesContainer.nativeElement.scrollHeight;
    }
  }

  async processMessageQueue(){
    console.log(this.isProcessingQueue, this.messageQueue.length);
    if (this.isProcessingQueue || this.messageQueue.length === 0) return;

    this.isProcessingQueue = true;
    const data = this.messageQueue.shift();



    this.web = data.web;
    this.module = data.module;
    this.state = data.state;
    this.moduleId = data.module_id;
    this.status = data.status;

    console.log("this.web ", this.web)
    console.log("this.module ", this.module)
    console.log("messageData", data)

    let mode = data.mode;

    let outputs = data.output;
    let key = data.key;
    if(this.state == data.state || this.web == "generate"){
      this.loadingMessage = false;
      this.disableInput = false;
    }

    if(this.state == data.state){
      this.remindCounter++;
    } else {
      this.thinkingMessage = false;
      this.remindCounter = 0;
      this.remind = false;
    }


    if(this.remindCounter > 5){
      this.remind = true;
    }

  //  if(this.state > 2000 || this.web == "generate"){
  //     this.isSidebarOpen = true;
  //   }

    // let content;
    // try {
    //   content = JSON.parse(data?.response?.content);
    // } catch (e) {
    //   console.error("Failed to parse AI response", e);
    //   this.isProcessingQueue = false;
    //   return this.processMessageQueue(); // move to next
    // }

    let message = data?.response?.content;
    let found = false;
    if(outputs != null){
      outputs.forEach(output => {
        if(output != null && data?.response?.json_config != null && data?.response?.json_config[output] != null){
          let value = data?.response?.json_config[output];
        }
      });
    }

    found = false;
    console.log("key", key);
    console.log("data?.response?.json_config", data?.response?.json_config);

    if(key != null){
      if(data?.response?.json_config != null && data?.response?.json_config[key] != null){
        found = true;
        console.log("++++++found++++++++++")
      }
    }
    if(found){
      this.loadingMessage = false;
      this.disableInput = true;
    }

      if(mode == "interactive" && message != null){
        this.messages.push({content: message?.replace(/\\n/g, '\n').replace(/\n/g, '\n\n'), role: "assistant"});
        this.displayedMessage = ''; // Clear previous message display
        this.messageIndex = 0;
        this.startTypingNewMessage(message);
      }

    if(this.web == "generate"){
            this.doneMessage = true;
        }

    setTimeout(() => {
      const inputArea = document.getElementById('inputArea');
      if (inputArea) {
        inputArea.focus();
      }
    }, 100);

    setTimeout(() => this.scrollToBottom(), 0);
    setTimeout(() => {
      if(this.scrollContainer?.nativeElement){
        const container = this.scrollContainer.nativeElement;
        container.scrollTop = container.scrollHeight;
      }
      // if (this.sidebarRef?.nativeElement) {
      //   const el = this.sidebarRef.nativeElement;
      //   el.scrollTo({ top: el.scrollHeight, behavior: 'smooth' });
      // }
    });
    this.isProcessingQueue = false;
    this.processMessageQueue();
  }

  // async handleMessageAnimation(message){
  //   this.messages.push({
  //     content: message?.replace(/\\n/g, '\n').replace(/\n/g, '\n\n'),
  //     role: "assistant"
  //   });
  //   this.displayedMessage = '';
  //   this.messageIndex = 0;
  //   await this.startTypingNewMessageAsync(message);
  // }

  delay(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  private startTypingNewMessage(newMessage: string): void {
    // Invalidate any ongoing typing session.
    this.typingSessionId++;
    this.messageIndex = 0;
    this.displayedMessage = '';

    // The local replacement for line-breaks or double line breaks:
    const processedMessage = newMessage
      .replace(/\\n/g, '\n')
      .replace(/\n/g, '\n\n');

    // Begin typing with the current session ID
    this.typeMessage(processedMessage, this.typingSessionId);
  }

  private typeMessage(message: string, sessionId: number) {
    if (sessionId !== this.typingSessionId) {
      return; // Stop typing.
    }

    if (this.messageIndex < message.length) {
      this.displayedMessage += message[this.messageIndex];
      this.messageIndex++;
      setTimeout(() => this.typeMessage(message, sessionId), this.typingSpeed);
      setTimeout(() => this.scrollToBottom(), 0);
      setTimeout(() => {
        const container = this.scrollContainer;
        if(container && container.nativeElement){
          container.nativeElement.scrollTop = container.nativeElement.scrollHeight;
        }
      });
    }
  }

  startTypingNewMessageAsync(newMessage: string): Promise<void> {
    return new Promise<void>((resolve) => {
      this.typingSessionId++;
      const currentSessionId = this.typingSessionId;
      this.messageIndex = 0;
      this.displayedMessage = '';

      const processedMessage = newMessage
        .replace(/\\n/g, '\n')
        .replace(/\n/g, '\n\n');

      const type = () => {
        if (currentSessionId !== this.typingSessionId) {
          return resolve(); // cancelled
        }

        if (this.messageIndex < processedMessage.length) {
          this.displayedMessage += processedMessage[this.messageIndex++];
          setTimeout(type, this.typingSpeed);

          setTimeout(() => {
            const container = this.scrollContainer;
            if (container?.nativeElement) {
              container.nativeElement.scrollTop = container.nativeElement.scrollHeight;
            }
          });
        } else {
          resolve(); // ✅ Done typing
        }
      };

      type();
    });
  }

    async generateApp(module, web){
      switch(module){
        case 'bot':
        switch(web){
          case 'generate':

            console.log("this.state", this.state)
              this.inputText ='Generate and Deploy'
              this.messages.push({content: this.inputText, role: "user"})
              this.ws.processMethod(new MessageAIModule(this.inputText, this.state, this.module, this.moduleId, this.component_ref, this.remind, true));
              this.doneMessage = false;
              this.disableInput = true;
              this.loadingMessage = true;
              this.thinkingMessage = true;
              setTimeout(() => this.scrollToBottom(), 0);
              setTimeout(() => {
                this.inputText = '';
                document.getElementById("inputArea").style.height = "";
                const container = this.scrollContainer?.nativeElement;
                if(container){
                  container.scrollTop = container.scrollHeight;
                }
              });
          break;
        }

        break;


      }


    }


  ngOnDestroy(): void {
    if(this.verifySubscription){
      this.verifySubscription.unsubscribe();
    }
    if(this.messageAIModuleSubscription){
      this.messageAIModuleSubscription.unsubscribe();
    }
    if(this.getAIModuleHistorySubscription){
      this.getAIModuleHistorySubscription.unsubscribe();
    }
    if(this.getAppConfigSubscription){
      this.getAppConfigSubscription.unsubscribe();
    }
    if(this.schemeChangeSubscription){
      this.schemeChangeSubscription.unsubscribe();
    }
    this.showGrid = false;
  }
}
